'use client';

import { useState, useEffect } from 'react';
import EntryModal from './EntryModal';
import { getCookie } from '@/lib/cookies';

type Store = {
  covaLocationId: number;
  name: string;
  city?: string;
  province?: string;
  address?: string;
};

type EntryModalWrapperProps = {
  stores: Store[];
  base: string;
};

const STORAGE_KEY = 'dank_entry_preferences';

export default function EntryModalWrapper({ stores, base }: EntryModalWrapperProps) {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // Check if user has valid saved preferences
    const stored = getCookie(STORAGE_KEY);
    if (stored) {
      try {
        const prefs = JSON.parse(stored);
        // Check if preferences are still valid (not expired)
        if (prefs.expiryDate && Date.now() < prefs.expiryDate && prefs.ageVerified) {
          // User has valid saved preferences, don't show modal
          setShowModal(false);
          return;
        }
      } catch (e) {
        // Invalid storage, show modal
      }
    }

    // Cleanup old localStorage value if present (legacy)
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch {}
    
    // Show modal on first visit or if preferences expired
    setShowModal(true);
  }, []);

  if (!showModal) {
    return null;
  }

  return <EntryModal stores={stores} base={base} onClose={() => setShowModal(false)} />;
}

